import type { ReviewRatingBucket } from "@circle-react/types/CommunityReview";

import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const reviews = {
  avg_rating: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/reviews/avg_rating", params),
  total_reviews: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/reviews/total_reviews", params),
  response_rate: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/reviews/response_rate", params),
  avg_rating_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/reviews/avg_rating_by_date",
      params,
    ),
  rating_distribution: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/reviews/rating_distribution",
      params,
    ),
  tag_votes: (bucket: ReviewRatingBucket, params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/reviews/tag_votes", {
      ...params,
      bucket,
    }),
};
